import { render, staticRenderFns } from "./list.vue?vue&type=template&id=03bda025&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=03bda025&prod&lang=scss&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports